// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcs_a bhf_rh bhf_ri bhf_vf bhf_ec bhf_vc bhf_gq bhf_kf"};